// @flow
import type { WindowType } from "common/consts/windowConsts"

export type WindowResizeAction = {|
  type: "WINDOW_RESIZE",
  windowType: WindowType,
  width: number,
|}

// eslint-disable-next-line import/prefer-default-export
export function resize(windowType: WindowType, width: number): WindowResizeAction {
  return {
    type: "WINDOW_RESIZE",
    windowType,
    width,
  }
}
